import EntidadesForm from "./../../components/auth/entidades-form";

const EntidadesPage = () => {
  return (
    <div>
      <EntidadesForm />
    </div>
  );
};

export default EntidadesPage;
